export function isWebsocketDebugEnabled() {
  return process.env.REACT_APP_WS_DEBUG === 'true';
}

export function websocketMessageSummary(message, payloadBytes) {
  return {
    command: message?.command,
    controllerId: message?.internal_id,
    zoned: Boolean(message?.is_zoned),
    payloadBytes
  };
}

export function websocketDebug(label, details) {
  if (isWebsocketDebugEnabled()) console.debug(label, details);
}
